import axiosInstance from '../axios.instance';

export const createOrderApi = (data, token) => axiosInstance.post('/order/create', data, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const makeBidApi = (data, token) => axiosInstance.post('/auction/bid', data, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getOrdersInfoApi = (token) => axiosInstance.get('/order/information', {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getOrdersApi = (token, type = 'purchases', status) => axiosInstance.get(`/order/${type}?type=${status}`, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getOneOrderApi = (token, orderLink) => axiosInstance.get(`/order/one/${orderLink}`, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const confirmOrderApi = (token, link) => axiosInstance.post(`/order/confirm/${link}`, null, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const cancelOrderApi = (token, link) => axiosInstance.post(`/order/cancel/${link}`, null, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const completeOrderApi = (token, link, code) => axiosInstance.post(`/order/completed/${link}?code=${code}`, null, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const sendCompletedCodeApi = (token, link) => axiosInstance.post(`/order/send-completed-code/${link}`, null, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const sendReviewApi = (token, link, text, rating) => axiosInstance.post(`/review/add-review/${link}`, {
  text,
  rating,
}, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});
